import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumTpPaymentMethod implements BaseEnumType {
  private static allValues: EnumTpPaymentMethod[] = []; // make sure this is top-most
  
  public static stripe = new EnumTpPaymentMethod(0, "Stripe", "enum_tp_payment_method_stripe");
  public static account = new EnumTpPaymentMethod(1, "Account", "enum_tp_payment_method_account");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumTpPaymentMethod.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isStripe() { return this === EnumTpPaymentMethod.stripe; }
  public isAccount() { return this === EnumTpPaymentMethod.account; }

  public static getValues(): readonly EnumTpPaymentMethod[] {
    return EnumTpPaymentMethod.allValues;
  }

  public static getValuesExcept0(): readonly EnumTpPaymentMethod[] {
    return EnumTpPaymentMethod.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumTpPaymentMethod {
    const found = EnumTpPaymentMethod.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumTpPaymentMethod - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumTpPaymentMethod): EnumTpPaymentMethod {
    const found = name ? EnumTpPaymentMethod.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumTpPaymentMethod - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumTpPaymentMethod>): boolean {
    return this.key === other?.key;
  }
}